import React, { Component } from 'react';

import CommunityUserProfile from './CommunityUserProfile';

class MainUserProfileContainerView extends Component {

    render() {
        return (
            <CommunityUserProfile personId={parseInt(this.props.routeParams.id, 10)}
                uniqueName={this.props.routeParams.unique_name}/>
        );
    }
}

export default MainUserProfileContainerView;
